import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { month } from "../../../Base/helper/baseFunctions";

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  section: {
    marginBottom: 5,
  },
  section2: {
    marginBottom: 2,
  },
  section0: {
    marginBottom: 5,
    fontSize: 8,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: 10,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 10,
  },
  table: {
    display: "flex",
    flexDirection: "column",
    borderWidth: 1,
    borderColor: "#000",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
  },
  tableRowTotal: {
    flexDirection: "row",
    borderTopWidth: 2,
    borderBottomWidth: 2,
    borderColor: "#000",
    paddingTop: 3,
    paddingRight: 1,
    paddingBottom: 3,
    paddingLeft: 1,
  },
  tableRowTotal1: {
    flexDirection: "row",
    borderTopWidth: 1,
    borderBottomWidth: 2,
    borderColor: "#000",
    backgroundColor: "#ffe78c",
    paddingTop: 3,
    paddingRight: 1,
    paddingBottom: 3,
    paddingLeft: 1,
  },
  tableRowTotal2: {
    flexDirection: "row",
    borderBottomWidth: 2,
    borderColor: "#000",
    backgroundColor: "#ffe78c",
    paddingTop: 3,
    paddingRight: 1,
    paddingBottom: 3,
    paddingLeft: 1,
  },
  tableRowTotal3: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderColor: "#000",
    backgroundColor: "#ffe78c",
    paddingTop: 3,
    paddingRight: 1,
    paddingBottom: 3,
    paddingLeft: 1,
  },
  tableCell: {
    flex: 1,
    padding: 3,
    fontSize: 6,
    textAlign: "center",
    borderColor: "#000",
  },
  tableCellParticulars: {
    flex: 1,
    paddingTop: 2,
    paddingRight: 1,
    paddingBottom: 2,
    paddingLeft: 1,
    fontSize: 6,
    textAlign: "left",
    borderColor: "#000",
  },
  tableCellActual: {
    flex: 1,
    paddingTop: 3,
    paddingRight: 2,
    paddingBottom: 3,
    paddingLeft: 2,
    marginLeft: -5,
    fontSize: 6,
    textAlign: "center",
    borderColor: "#000",
  },
  tableCellMonth: {
    flex: 1,
    paddingTop: 3,
    paddingRight: 1,
    paddingBottom: 3,
    paddingLeft: 1,
    fontSize: 6,
    textAlign: "right",
    borderColor: "#000",
  },
  numberCell: {
    flex: 1,
    paddingTop: 3,
    paddingRight: 1,
    paddingBottom: 3,
    paddingLeft: 1,
    fontSize: 6,
    textAlign: "right",
    borderColor: "#000",
  },
  tableCellParticulars2: {
    flex: 1,
    paddingTop: 2,
    paddingRight: 1,
    paddingBottom: 2,
    paddingLeft: 1,
    fontSize: 6,
    textAlign: "left",
    borderColor: "#000",
    borderWidth: 0,
  },
  numberCell2: {
    flex: 1,
    paddingTop: 2,
    paddingRight: 1,
    paddingBottom: 2,
    paddingLeft: 1,
    fontSize: 6,
    textAlign: "right",
    borderColor: "#000",
    borderWidth: 0,
  },
  flexCenter: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 3,
  },
  headerCell: {
    fontWeight: "bold",
  },
  headerCell1: {
    fontWeight: "bold",
    backgroundColor: "#e0e0e0",
  },
  headerCell2: {
    fontWeight: "bold",
  },

  fullWidthBox: {
    width: "100%",
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 1,
  },
  childBox: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#000",
    backgroundColor: "#f5f5f5",
    padding: 1,
  },

});

const TaxReport = ({
  data,
  slabSplitData,
  actualMonths,
  projectedMonths,
  allMonths,
  checkRegimeOpted,
  result,
  calculateOverallTotal,
  totalEarnings,
  allSumSection,
  sectionSummary,
  taxableIncome,
  companyName,
  fromYear,
  toYear

}) => {
  const formatAmount = (value) => {
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };
  const toCamelCaseLabel = (str) => {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const calculateComponentTotal = (data, component) => {
    return allMonths.reduce((total, month) => {
      return total + (data?.[component]?.[month] || 0);
    }, 0);
  };

  // column Total Calcultor
  const calculateMonthTotal = (data, month) => {
    return Object.keys(data).reduce((total, component) => {
      return total + (data?.[component]?.[month] || 0);
    }, 0);
  };
  const netSalary =
    Number(totalEarnings) -
    (Number(data?.tax_summary?.profession_tax) +
      Number(data?.tax_summary?.standard_deduction));
  const slabData =
    slabSplitData?.fn_get_tax_report_regime_split_calculation?.length > 0
      ? slabSplitData?.fn_get_tax_report_regime_split_calculation
      : [];
  const totalTax = slabData?.filter((el) => el.slab === "FINAL TOTAL TAX")[0]
    ?.tax_amount;
  const balanceTax =
    Number(totalTax) - Number(data?.tax_summary?.tax_deducted_at_source);
  const monthlyTax =
    balanceTax / Number(data?.tax_summary?.balance_no_of_months);

  projectedMonths.forEach((month) => {
    if (!result.deductions["income_tax"]) {
      result.deductions["income_tax"] = {};
    }
    result.deductions["income_tax"][month] = monthlyTax;
  });
  const earningComponents = Object.keys(result?.earnings);
  const deductionComponents = Object.keys(result?.deductions);
  const totalDeductions = calculateOverallTotal(result?.deductions);
  // Calculate Net Pay for each month
  const netPayPerMonth = allMonths.map((month) => {
    const earnings = calculateMonthTotal(result?.earnings, month);
    const deductions = calculateMonthTotal(result?.deductions, month);
    return earnings - deductions;
  });

 const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  let taxReportMonth = {};

  if (fromYear && toYear) {
    const startOfFY = new Date(fromYear, 3, 1); 
    const endOfFY = new Date(toYear, 2, 31);  

    if (currentDate >= startOfFY && currentDate <= endOfFY) {
      taxReportMonth = {
        month: month[currentMonthIndex],
        year: currentYear,
      };
    } else {
      taxReportMonth = {
        month: "March",
        year: toYear,
      };
    }
  }
  // Calculate Overall Net Pay
  const overallNetPay = netPayPerMonth.reduce((sum, val) => sum + val, 0);
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section0}>
          <Text style={styles.title}>{companyName}</Text>
          <Text style={styles.title}>TAX FORECAST FOR THE MONTH OF {taxReportMonth?.month?.toUpperCase()}-{taxReportMonth?.year}</Text>
        </View>

        <View style={styles.section0}>
          <View>
            <Text>Employee: {data?.employee_info?.[0]?.employee_name}</Text>
          </View>
          <View>
            <Text>DOB: {data?.employee_info?.[0]?.dob}</Text>
            <Text>Gender: {data?.employee_info?.[0]?.gender}</Text>
          </View>
          <View>
            <Text>Tax Regime Opted: {checkRegimeOpted()}</Text>
            <Text>Branch: {data?.employee_info?.[0]?.job_location}</Text>
          </View>
          <View>
            <Text>PAN: {data?.employee_info?.[0]?.pan}</Text>
            <Text>DOJ: {data?.employee_info?.[0]?.doj}</Text>
          </View>
        </View>

        <View style={styles.section}>
          <View style={styles.table}>
            
            <View style={{ flexDirection: "row", alignItems: "center", height: 14, borderBottomWidth: 1 }}>
              {/* Empty cell for "Particulars" */}
              <View style={{ flex: 1 }} />

              <Text style={{ fontSize: 6, color: "black", fontWeight: "bold" }}>[</Text>
              <View style={{ flex: 4, borderTopWidth: 1, borderColor: "#ffe78c" }} />
              <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 6, color: "black", fontWeight: "bold" }}>{fromYear}</Text>
              </View>
              <View style={{ flex: 4.5, borderTopWidth: 1, borderColor: "#ffe78c" }} />
              <Text style={{ fontSize: 6, color: "black", fontWeight: "bold" }}>]</Text>

              <View style={{ flex: 0.3 }} />

              <Text style={{ fontSize: 6, color: "black", fontWeight: "bold" }}>[</Text>
              <View style={{ flex: 0.7, borderTopWidth: 1, borderColor: "#ffe78c" }} />
              <View style={{ flex: 1, justifyContent: "center", alignItems: "center" }}>
                <Text style={{ fontSize: 6, color: "black", fontWeight: "bold" }}>{toYear}</Text>
              </View>
              <View style={{ flex: 1, borderTopWidth: 1, borderColor: "#ffe78c" }} />
              <Text style={{ fontSize: 6, color: "black", fontWeight: "bold" }}>]</Text>

              <View style={{ flex: 1 }} />
            </View>

            {/* Header Labels Row */}
            <View style={styles.tableRow}>
              {/* Empty cell for alignment */}
              <Text style={styles.tableCell}></Text>

              {/* Single "Actual" header spanning all actualMonths */}
              {actualMonths?.length > 0 && (
                <Text
                  style={[
                    styles.tableCellActual,
                    styles.headerCell1,
                    { flex: actualMonths.length },
                  ]}
                >
                  Actual
                </Text>
              )}

              {/* Single "Projected" header spanning all projectedMonths */}
              {projectedMonths?.length > 0 && (
                <Text
                  style={[
                    styles.tableCell,
                    styles.headerCell2,
                    { flex: projectedMonths.length },
                  ]}
                >
                  Projected
                </Text>
              )}

              {/* Empty cell for alignment */}
              <Text style={styles.tableCell}></Text>
            </View>

            {/* Column Titles */}
            <View style={[styles.tableRow, styles.headerCell]}>
              <Text style={styles.tableCellParticulars}>Particulars</Text>
              {actualMonths.map((month, i) => (
                <Text
                  key={i}
                  style={{ ...styles.tableCellMonth, ...styles.headerCell1 }}
                >
                  {month}
                </Text>
              ))}
              {projectedMonths.map((month, i) => (
                <Text
                  key={i}
                  style={{ ...styles.tableCellMonth, ...styles.headerCell2 }}
                >
                  {month}
                </Text>
              ))}
              <Text style={styles.tableCellMonth}>Total</Text>
            </View>

            {/* body Earnings Rows */}
            {earningComponents?.map((item, rowIndex) => (
              <View key={rowIndex} style={styles.tableRow}>
                <Text style={styles.tableCellParticulars}>
                  {toCamelCaseLabel(item)}
                </Text>
                {allMonths?.map((month) => (
                  <Text key={month} style={styles.numberCell}>
                    {result?.earnings[item]?.[month] != null
                      ? Number(result?.earnings[item][month])?.toFixed(2)
                      : (0).toFixed(2)}
                  </Text>
                ))}
                <Text style={styles.numberCell}>
                  {" "}
                  {!isNaN(calculateComponentTotal(result?.earnings, item))
                    ? Number(
                      calculateComponentTotal(result?.earnings, item)
                    ).toFixed(2)
                    : (0).toFixed(2)}
                </Text>
              </View>
            ))}
            {/* footer */}
            {/*monthWise Total Earnings */}
            <View style={styles.tableRowTotal1}>
              <Text style={styles.tableCellParticulars}>Total Earnings</Text>
              {allMonths?.map((month, i) => (
                <Text key={i} style={styles.numberCell}>
                  {!isNaN(calculateMonthTotal(result?.earnings, month))
                    ? Number(
                      calculateMonthTotal(result?.earnings, month)
                    ).toFixed(2)
                    : (0).toFixed(2)}
                </Text>
              ))}
              <Text style={styles.numberCell}>
                {Number(totalEarnings)?.toFixed(2)}
              </Text>
            </View>

            {/* body dudction components */}
            {deductionComponents?.map((item, rowIndex) => (
              <View key={rowIndex} style={styles.tableRow}>
                <Text style={styles.tableCellParticulars}>
                  {toCamelCaseLabel(item)}
                </Text>
                {allMonths?.map((month) => (
                  <Text key={month} style={styles.numberCell}>
                    {result?.deductions[item]?.[month] != null
                      ? Number(result?.deductions[item][month])?.toFixed(2)
                      : 0?.toFixed(2)}
                  </Text>
                ))}
                <Text style={styles.numberCell}>
                  {!isNaN(calculateComponentTotal(result?.deductions, item))
                    ? Number(
                      calculateComponentTotal(result?.deductions, item)
                    )?.toFixed(2)
                    : (0).toFixed(2)}
                </Text>
              </View>
            ))}
            {/*monthWise Total deduction */}
            <View style={styles.tableRowTotal1}>
              <Text style={styles.tableCellParticulars}>Total Deductions</Text>
              {allMonths?.map((month, i) => (
                <Text key={i} style={styles.numberCell}>
                  {!isNaN(calculateMonthTotal(result?.deductions, month))
                    ? Number(
                      calculateMonthTotal(result?.deductions, month)
                    )?.toFixed(2)
                    : (0).toFixed(2)}
                </Text>
              ))}
              <Text style={styles.numberCell}>
                {Number(totalDeductions)?.toFixed(2)}
              </Text>
            </View>
            {/* After a section like Total Earnings row */}

            {/* Net Pay */}
            <View style={styles.tableRowTotal3}>
              <Text style={styles.tableCellParticulars}>Net Pay</Text>
              {netPayPerMonth.map((val, i) => (
                <Text key={i} style={styles.numberCell}>
                  {Number(val)?.toFixed(2)}
                </Text>
              ))}
              <Text style={styles.numberCell}>
                {Number(overallNetPay)?.toFixed(2)}
              </Text>
            </View>
            {/* After a section like Total Earnings row */}
          </View>
        </View>
        <View style={styles.fullWidthBox}>
          {/* Child Box 1 */}
          <View style={styles.childBox}>
            <View style={{ ...styles.flexCenter, borderBottomWidth: 1 }}>
              <Text style={styles.tableCellParticulars2}>TAX CALCULATIONS</Text>
              <Text
                style={styles.numberCell2}
              >{`${checkRegimeOpted()} REGIME`}</Text>
            </View>
            <View style={styles.flexCenter}>
              <Text style={styles.tableCellParticulars2}>TOTAL EARNING</Text>
              <Text style={styles.numberCell2}>
                {Number(totalEarnings)?.toFixed(2)}
              </Text>
            </View>
            <View style={styles.flexCenter}>
              <Text style={styles.tableCellParticulars2}>TOTAL GROSS</Text>
              <Text style={styles.numberCell2}>
                {Number(totalEarnings)?.toFixed(2)}
              </Text>
            </View>

            <View style={{ ...styles.flexCenter, marginTop: 1 }}>
              <Text style={styles.tableCellParticulars2}>
                LESS: PROFESSION TAX
              </Text>
              <Text style={styles.numberCell2}>
                {formatAmount(data?.tax_summary?.profession_tax)}
              </Text>
            </View>
            <View style={{ ...styles.flexCenter, marginTop: 1 }}>
              <Text style={styles.tableCellParticulars2}>
                LESS: STANDARD DEDUCTION
              </Text>
              <Text style={styles.numberCell2}>
                {formatAmount(data?.tax_summary?.standard_deduction)}
              </Text>
            </View>
            <View style={{ ...styles.flexCenter, marginTop: 1 }}>
              <Text style={styles.tableCellParticulars2}>NET SALARY</Text>
              <Text style={styles.numberCell2}>{formatAmount(netSalary)}</Text>
            </View>
            {sectionSummary.map((item, index) => (
              <View key={index} style={{ ...styles.flexCenter, marginTop: 1 }}>
                <Text style={styles.tableCellParticulars2}>
                  LESS: Section {item.section}
                </Text>
                <Text style={styles.numberCell2}>
                  {item?.total?.toFixed(2)}
                </Text>
              </View>
            ))}

            {/* Grand Total Row */}
            <View style={{ ...styles.flexCenter, marginTop: 5 }}>
              {/* Taxable Income-- net slaray - allSumSection */}
              <Text style={styles.tableCellParticulars2}>TAXABLE INCOME</Text>
              <Text style={styles.numberCell2}>
                {(netSalary - Number(allSumSection)).toFixed(2)}
              </Text>
            </View>
            <View style={{ ...styles.flexCenter, marginTop: 1 }}>
              {/* will come from when taxable income is sent in api = return value in Total Tax */}
              <Text style={styles.tableCellParticulars2}>TOTAL TAX</Text>
              <Text style={styles.numberCell2}>
                {Number(totalTax).toFixed(2)}
              </Text>
            </View>
            <View style={{ ...styles.flexCenter, borderTopWidth: 1 }}>
              {/* will come from when taxable income is sent in api = return value in Total Tax */}
              <Text style={styles.tableCellParticulars2}>
                {`TAX APPLIED AS PER ${checkRegimeOpted()} REGIME`}
              </Text>
              <Text style={styles.numberCell2}>
                {Number(totalTax).toFixed(2)}
              </Text>
            </View>
            <View style={{ ...styles.flexCenter, borderTopWidth: 1 }}>
              <Text style={styles.tableCellParticulars2}>
                LESS: TAX DEDUCTED AT SOURCE
              </Text>
              <Text style={styles.numberCell2}>
                {formatAmount(data?.tax_summary?.tax_deducted_at_source)}
              </Text>
            </View>
            <View style={{ ...styles.flexCenter, marginTop: 1 }}>
              <Text style={styles.tableCellParticulars2}>
                BALANCE TAX PAYABLE
              </Text>
              <Text style={styles.numberCell2}>{balanceTax?.toFixed(2)}</Text>
            </View>
            <View style={{ ...styles.flexCenter, marginTop: 1 }}>
              <Text style={styles.tableCellParticulars2}>
                BALANCE NUMBER OF MONTHS
              </Text>
              <Text style={styles.numberCell2}>
                {data?.tax_summary?.balance_no_of_months}
              </Text>
            </View>
            <View style={{ ...styles.flexCenter, marginTop: 1 }}>
              <Text style={styles.tableCellParticulars2}>MONTHLY TAX</Text>
              <Text style={styles.numberCell2}>{monthlyTax?.toFixed(2)}</Text>
            </View>
          </View>

          {/* Child Box 2 */}
          <View style={styles.childBox}>
            {data?.declarations &&
              Object.entries(data.declarations)
                .filter(
                  ([section]) =>
                    checkRegimeOpted() === "OLD" || section === "Section 24"
                )
                .map(([section, entries], sectionIndex) => {
                   let components = {};

                  if (["House Rent Exemption", "Section 24"].includes(section)) {
                    // Merge all objects in the array by summing their values
                    const safeEntries = Array.isArray(entries) ? entries : [];
                    components = safeEntries?.reduce((acc, obj) => {
                      for (const [key, value] of Object.entries(obj)) {
                        acc[key] = (acc[key] || 0) + (Number(value) || 0);
                      }
                      return acc;
                    }, {});
                  } else {
                    components = entries?.[0] || {};
                  }
                  // Filter components with non-zero values
                  const filteredComponents = Object.entries(components).filter(
                    ([, value]) => value != null && Number(value) !== 0
                  );

                  const hasFilteredComponents = filteredComponents.length > 0;
                  return (
                    <View key={sectionIndex} style={styles.section2}>
                      {/* Section Label */}
                      <View style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}>
                        <Text
                          style={{
                            fontSize: 7,
                            fontWeight: "bold",
                            marginTop: 2,
                          }}
                        >
                          Section: {section} .............................
                        </Text>
                        {!hasFilteredComponents && (
                          <Text style={{ fontSize: 7, marginTop: 2, fontStyle: "italic" }}>N.A</Text>
                        )}

                      </View>
                      {/* Component Rows */}
                      {hasFilteredComponents &&
                        filteredComponents?.map(
                          ([comp, value], compIndex) => (
                            <View
                              key={compIndex}
                              style={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginTop: 2,
                              }}
                            >
                              <Text style={{ width: "70%", fontSize: 6 }}>
                                {comp}
                              </Text>
                              <Text
                                style={{
                                  width: "30%",
                                  textAlign: "right",
                                  fontSize: 6,
                                }}
                              >
                                {(value ?? 0).toFixed(2)}
                              </Text>
                            </View>
                          )
                        )}
                    </View>
                  );
                })}
            {/* proof received */}
            {data?.proofs_received &&
              <View style={{ ...styles.flexCenter, borderTopWidth: 1 }}>
                <Text style={{
                  fontSize: 7,
                  fontWeight: "bold",
                  marginTop: 2
                }}>
                  PROOF RECEIVED
                </Text>
                <Text style={styles.numberCell2}>
                </Text>
              </View>
            }
            {data?.proofs_received &&
              Object.entries(data.proofs_received)
                .filter(
                  ([section]) =>
                    checkRegimeOpted() === "OLD" || section === "Section 24"
                )
                .map(([section, entries], sectionIndex) => {
                  let components = {};

                  if (["House Rent Exemption", "Section 24"].includes(section)) {
                    // Merge all objects in the array by summing their values
                    const safeEntries = Array.isArray(entries) ? entries : [];
                    components = safeEntries?.reduce((acc, obj) => {
                      for (const [key, value] of Object.entries(obj)) {
                        acc[key] = (acc[key] || 0) + (Number(value) || 0);
                      }
                      return acc;
                    }, {});
                  } else {
                    components = entries?.[0] || {};
                  }
                  // Filter components with non-zero values
                  const filteredComponents = Object.entries(components).filter(
                    ([, value]) => value != null && Number(value) !== 0
                  );

                  const hasFilteredComponents = filteredComponents.length > 0;

                  return (
                    <View key={sectionIndex} style={styles.section2}>
                      {/* Section Label */}
                      <View style={{
                        flexDirection: "row",
                        justifyContent: "space-between",
                      }}>
                        <Text
                          style={{
                            fontSize: 7,
                            fontWeight: "bold",
                            marginTop: 2,
                          }}
                        >
                          Section: {section} .............................
                        </Text>
                        {!hasFilteredComponents && (
                          <Text style={{ fontSize: 7, marginTop: 2, fontStyle: "italic" }}>N.A</Text>
                        )}

                      </View>

                      {/* Component Rows */}
                      {hasFilteredComponents &&
                        filteredComponents?.map(
                          ([comp, value], compIndex) => (
                            <View
                              key={compIndex}
                              style={{
                                flexDirection: "row",
                                justifyContent: "space-between",
                                marginTop: 2,
                              }}
                            >
                              <Text style={{ width: "70%", fontSize: 6 }}>
                                {comp}
                              </Text>
                              <Text
                                style={{
                                  width: "30%",
                                  textAlign: "right",
                                  fontSize: 6,
                                }}
                              >
                                {(value ?? 0).toFixed(2)}
                              </Text>
                            </View>
                          )
                        )}
                    </View>
                  );
                })}
          </View>

          {/* Child Box 3 */}
          <View style={styles.childBox}>
            <View
              style={{ ...styles.flexCenter, marginTop: 1, marginBottom: 2 }}
            >
              <View style={{ flex: 0.7 }}>
                <Text style={styles.tableCellParticulars2}>
                  TAX CALCULATIONS ON TAXABLE INCOME
                </Text>
              </View>
              <View style={{ flex: 0.3 }}>
                <Text style={styles.numberCell2}>{taxableIncome.toFixed(2)}</Text>
              </View>
            </View>
            {slabData?.map((item, index) => (
              <View key={index} style={{ ...styles.flexCenter }}>
                <View style={{ flex: 0.74 }}>
                  {item.slab === "TOTAL TAX" || item.slab === "EDUCATION CESS @ 4%" || item.slab === "FINAL TOTAL TAX" ? (
                    <Text style={{ ...styles.tableCellParticulars2, marginTop: "-5px" }}>
                      {item.slab}
                    </Text>
                  ) : (
                    <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                      <Text style={styles.tableCellParticulars2}>
                        {`${item.slab} : `}
                      </Text>
                      <Text style={{ ...styles.tableCellParticulars2, textAlign: "right" }}>
                        {`${item.amount_in_slab} x ${item.tax_percent}%`}
                      </Text>
                    </View>
                  )}
                </View>
                <View style={{ flex: 0.04, display: "flex", flexDirection: "row", justifyContent: "space-around" }} >
                  <Text style={{ ...styles.numberCell2 }}>
                    {`=`}
                  </Text>
                </View>
                <View style={{ flex: 0.22, display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
                  <Text style={{ ...styles.numberCell2 }}>
                    {Number(item.tax_amount)?.toFixed(2)}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default TaxReport;
